var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ImmersivePage",
    {
      attrs: {
        icon: "back",
        appBarTitle: _vm.appBarTitle,
        route: _vm.backRoute,
      },
    },
    [
      _c(
        "KPageContainer",
        { staticClass: "device-container" },
        [
          _vm.wholePageError
            ? _c("ContentWizardUiAlert", {
                attrs: { errorType: _vm.wholePageError },
              })
            : [
                !_vm.onDeviceInfoIsReady ? _c("TaskProgress") : _vm._e(),
                _vm.onDeviceInfoIsReady
                  ? [
                      _vm.transferredChannel && _vm.onDeviceInfoIsReady
                        ? _c(
                            "section",
                            { staticClass: "updates" },
                            [
                              _vm.newVersionAvailable
                                ? _c("NewChannelVersionBanner", {
                                    staticClass: "banner",
                                    attrs: {
                                      version: _vm.availableVersions.source,
                                    },
                                    on: {
                                      click: _vm.handleClickViewNewVersion,
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c("ChannelContentsSummary", {
                        attrs: {
                          channel: _vm.transferredChannel,
                          channelOnDevice: _vm.channelOnDevice,
                          freeSpace: _vm.availableSpace,
                        },
                      }),
                      _vm.status !== ""
                        ? _c(
                            "UiAlert",
                            { attrs: { type: "error", dismissible: false } },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$tr("problemFetchingChannel")) +
                                  "\n        "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.contentTransferError
                        ? _c(
                            "UiAlert",
                            { attrs: { type: "error", dismissible: false } },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$tr("problemTransferringContents")
                                  ) +
                                  "\n        "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "UiAlert",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isFileSpaceEnough,
                              expression: "isFileSpaceEnough",
                            },
                          ],
                          attrs: { dismissible: false, type: "error" },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.deviceString(
                                  "notEnoughSpaceForChannelsWarning"
                                )
                              ) +
                              "\n        "
                          ),
                        ]
                      ),
                      !_vm.newVersionAvailable
                        ? _c("ContentTreeViewer", {
                            staticClass: "block-item",
                            class: { small: _vm.windowIsSmall },
                            style: {
                              borderBottomColor: _vm.$themeTokens.fineLine,
                            },
                          })
                        : _vm._e(),
                    ]
                  : _vm._e(),
              ],
          !_vm.newVersionAvailable
            ? _c("SelectionBottomBar", {
                attrs: {
                  objectType: "resource",
                  actionType: "import",
                  resourceCounts: {
                    count: _vm.transferResourceCount,
                    fileSize: _vm.transferFileSize,
                  },
                  disabled:
                    _vm.disableBottomBar ||
                    _vm.newVersionAvailable ||
                    _vm.isFileSpaceEnough,
                },
                on: { clickconfirm: _vm.handleClickConfirm },
              })
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }